import React from 'react';
import { config } from '../../../services/config';
import { CUSTOM_FUNCTIONS } from '../../../constants/CUSTOM_FUNCTIONS';
import { orderBy } from 'lodash';
import { useIntl } from 'react-intl';
import { configMessages } from '../../../lang/messages';

import Page from './Page';

interface Props {
  assemblyGeneral: any;
  assemblyComponents: any;
  exportDate: string;
  exportTimestamp: number;
  time?: number;
  pageNumber: number;
  totalPageNumber: number;
}

const SchemaPFD = ({
  assemblyGeneral,
  assemblyComponents,
  exportDate,
  exportTimestamp,
  time,
  pageNumber,
  totalPageNumber
}: Props) => {
  let components = assemblyComponents
    .filter((c) => c.type === 'function')
    .sort((c1, c2) => c1.viewer2D.x - c2.viewer2D.x);

  const intl = useIntl();

  const componentTypes = components.map((c) => c.data.type);
  const uniqueTypes = new Set([...componentTypes]);

  let fcts = [];
  uniqueTypes.forEach((type) => {
    fcts.push(CUSTOM_FUNCTIONS[type]);
  });

  const sortedFunctions = orderBy(fcts, ['name'], ['asc']);

  return (
    <Page isLastpage={totalPageNumber === pageNumber}>
      <div className="border-bottom py-2">
        <div className="f-row f1-between f2-center">
          <div>
            <span>{intl.formatMessage(configMessages.PFD)}</span>
            <span className="px-2">&#124;</span>
            <span className="font-regular">{assemblyGeneral.name}</span>
          </div>
          <div>{exportDate}</div>
        </div>
      </div>
      <div
        className="f-full f-center mt-1 mb-2"
        style={{
          height: 400,
          backgroundImage:
            'url(' +
            config.BlobURL +
            '/single-use-configurator/assemblies/thumbnail/' +
            assemblyGeneral.id +
            '_UO_Annotated_PFD' +
            '.png?nocache=' +
            exportTimestamp +
            ')',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'
        }}></div>

      <div className="col-count-5 px-2" style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
        {sortedFunctions.map((fct) => {
          return (
            <div key={fct?.name} className="f-row f2-start gap-2">
              <div>{fct?.form(20)}</div>
              <div style={{ lineHeight: '18px' }}>{fct?.name}</div>
            </div>
          );
        })}
      </div>
      <div className="f-row f1-end gap-2 mt-3" style={{ fontSize: 13 }}>
        <div>{`Page ${pageNumber}/${totalPageNumber}`}</div>
      </div>
    </Page>
  );
};

export default SchemaPFD;
